import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom'
import DashboardHeader from '../shared/components/DashboardHeader';
import SideMenu from '../shared/components/SideMenu';
import Footer from '../shared/components/Footer';

export default function SequenceBreakdown() {

    const user = JSON.parse(localStorage.getItem('user'))
    
    return(
        <>
            <DashboardHeader />
            <div className="container-fluid page-body-wrapper">
            <SideMenu />
            <div class="main-panel">
        <div class="content-wrapper">
          <div class="row">
            
          <div class="col-md-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Sequence Breakdown</h4>
                  <p class="card-description">
                    You can always feel confident that your credit card information is safe and secure at GetBound.
                  </p>
                  <form class="forms-sample">
                   

                    <div class="row">

                        
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>Day</label>
                          <input type="number" class="form-control form-control-lg" placeholder="Enter day" />
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label>Due Date</label>
                          <input type="Date" class="form-control form-control-lg" placeholder="Enter day" />
                        </div>
                      </div>

                      <div class="col-md-12">
                        <div class="form-group">
                          <label>Sequence Title</label>
                          <input type="name" class="form-control form-control-lg" placeholder="Sequence title" />
                        </div>
                      </div>
                      
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>Lead List</label>
                          <select className="js-example-basic-single w-100 customselect form-control form-control-lg">
                          <option value="">Select your lead list</option>
                        </select>
                        </div>
                      </div>
                      

                      <div class="col-md-12">
                        <div class="form-group">
                          <label>Sequence Activity</label>
                          <textarea className="form-control form-control-lg customtextarea"name="template" placeholder="Sequence Activity" rows="17"></textarea>
                        </div>
                      </div>



                      <div class="col-md-12">
                      <div className="form-group">
                        <label>Attachments File (IMAGE/CSV/PDF/DOC)</label>

                        <div className="input-group col-xs-12">
                          <input type="file" multiple accept="image/*, .doc,.docx,.csv,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,.pdf" className="form-control file-upload-info form-control-lg marginsmall customchoosefile" placeholder="Upload File (IMAGE/CSV/PDF/DOC)" />

                        </div>
                      </div>
                      </div>


                    </div>

                    <div class="row">
                    <div class="col-md-2 text-center">
                        <i className='btn mdi mdi-arrow-left customarrow'></i>
                    </div>
                    <div class="col-md-3">
                      <button type="submit" class="btn btn-primary me-2 savebtn">Save</button>
                    </div>
                    <div class="col-md-3">
                      <button class="btn btn-light me-2 savebtn">Clear</button>
                    </div>
                    <div class="col-md-2 text-center">
                        <i className='btn mdi mdi-arrow-right customarrow'></i>
                    </div>
                    <div class="col-md-2 text-center">
                      <b className='custompagesnumber'>01 <i className='mdi mdi-minus'></i> 299</b>
                    </div>
                    </div>
                    
                  </form>
                </div>
              </div>
            </div>

            <div class="col-md-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Lead List Breakdown</h4>
                  <p class="card-description">
                    You can always feel confident that your credit card information is safe and secure at GetBound.
                  </p>
                  <form class="forms-sample">
                   

                    <div class="row">

                        
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>First Name</label>
                          <input type="name" class="form-control form-control-lg" placeholder="First Name" />
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label>Last Name</label>
                          <input type="name" class="form-control form-control-lg" placeholder="Last Name" />
                        </div>
                      </div>

                      <div class="col-md-12">
                        <div class="form-group">
                          <label>Company Name</label>
                          <input type="name" class="form-control form-control-lg" placeholder="Company Name" />
                        </div>
                      </div>

                      <div class="col-md-12">
                        <div class="form-group">
                          <label>Email</label>
                          <input type="name" class="form-control form-control-lg" placeholder="Email" />
                        </div>
                      </div>
                      
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>Other refs</label>
                          <input type="name" class="form-control form-control-lg" placeholder="urls" />
                        </div>
                      </div>
                      

                      <div class="col-md-6">
                        <div class="form-group">
                          <label>Status</label>
                          <select className="js-example-basic-single w-100 customselect form-control form-control-lg">
                          <option value="">Status</option>
                          <option value="">Sent</option>
                          <option value="">Replies</option>
                          <option value="">Not Compliant</option>
                          <option value="">Sending Failed</option>
                        </select>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label>Action Taken</label>
                          <input type="Date" class="form-control form-control-lg" placeholder="Enter day" />
                        </div>
                      </div>
              

                      <div class="col-md-12">
                        <div class="form-group">
                          <label>Remarks</label>
                          <textarea className="form-control form-control-lg customtextarea"name="template" placeholder="Remarks" rows="10"></textarea>
                        </div>
                      </div>

                    </div>

                    <div class="row">
                    <div class="col-md-2 text-center">
                        <i className='btn mdi mdi-arrow-left customarrow'></i>
                    </div>
                    <div class="col-md-3">
                      <button type="submit" class="btn btn-primary me-2 savebtn">Save</button>
                    </div>
                    <div class="col-md-3">
                      <button class="btn btn-light me-2 savebtn">Clear</button>
                    </div>
                    <div class="col-md-2 text-center">
                        <i className='btn mdi mdi-arrow-right customarrow'></i>
                    </div>
                    <div class="col-md-2 text-center">
                      <b className='custompagesnumber'>01 <i className='mdi mdi-minus'></i> 299</b>
                    </div>
                    </div>
                    
                  </form>
                </div>
              </div>
            </div>

            <div id="RequestModal" class="modal">
              <div class="modal-content">
                <span class="close1 closebtn">&times;</span>
               
                <div class="row">

                                          
                <div class="col-md-4">
                        <div class="form-group text-left">
                          <label>Activity Status</label>
                          <select className="js-example-basic-single w-100 customselect form-control form-control-lg">
                          <option value="">Answered</option>
                          <option value="">Sending Failed</option>
                          <option value="">Data Not Compliant</option>
                          <option value="">Pending Request</option>
                          <option value="">Not Anwsered</option>
                          <option value="">Not Interested</option>
                          <option value="">Response/ Meetings</option>
                        </select>
                        </div>
                      </div>

                      <div class="col-md-4">
                        <div class="form-group text-left">
                          <label>Executed On </label>
                          <input type="Date" class="form-control form-control-lg" placeholder="Enter day" />
                        </div>
                      </div>
                  
                  <div class="col-md-4">
                        <div class="form-group text-left">
                          <label>Next Action Date</label>
                          <input type="Date" class="form-control form-control-lg" placeholder="Enter day" />
                        </div>
                      </div>
              

                      <div class="col-md-12">
                        <div class="form-group text-left">
                          <label>Remarks</label>
                          <textarea className="form-control form-control-lg customtextarea"name="template" placeholder="Remarks" rows="10"></textarea>
                        </div>
                      </div>

              </div>
              
              <button type="button" class="btn btn-primary btn-rounded btn-md">Save</button>
              <button type="button" class="btn btn-rounded btn-md">Cancel</button>
              </div>
            </div>

            <div class="col-md-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  
                <h4 class="card-title">Lead List</h4>

                  <div class="form-group customsearchbar">
                    <div class="input-group">
                      <input type="text" class="form-control" placeholder="Search Lead List" aria-label="Search"/>
                      <div class="input-group-append">
                        <button class="btn btn-sm btn-primary" type="button">Search</button>
                      </div>
                    </div>
                  </div>



                  <div class="table-responsive">
                    <table class="table table-hover">
                      <thead>
                        <tr>
                          <th>Edit</th>
                          <th>#</th>
                          <th>Activity Status</th>
                          <th>Executed On</th>
                          <th>Next Action Date</th>
                          <th className='textunset'>Agent Remarks </th>
                          <th>First Name</th>
                          <th>Last Name</th>
                          <th>Job Title</th>
                          <th>Job Function</th>
                          <th>Management Level</th>
                          <th>Direct Phone Number</th>
                          <th>Email Address</th>
                          <th>Email Domain</th>
                          <th>Department</th>
                          <th>Mobile Phone</th>
                          <th>ZoomInfo Contact Profile URL</th>
                          <th>LinkedIn Contact Profile URL</th>
                          <th>Person Street</th>
                          <th>Person City</th>
                          <th>Person State</th>
                          <th>Person Zip Code</th>
                          <th>Country</th>
                          <th>Company Name</th>
                          <th>Website</th>
                          <th>Company HQ Phone</th>
                          <th>Business Model</th>
                          <th>Company Street Address</th>
                          <th>Company City</th>
                          <th>Company State</th>
                          <th>Company Zip Code</th>
                          <th>Company Country</th>
                          <th>Full Address</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <button type="button" class="btn customroweditbtn">
                             <i class="mdi mdi-dots-vertical"></i>
                            </button>
                          </td>
                          <td>01</td>
                          <td>Answered</td>
                          <td>02-08-2023</td>
                          <td>15-10-2023</td>
                          <td className='textunset'>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words</td>
                          <td>Barbara</td>
                          <td>Brown</td>
                          <td>Sams Club Vice President, Marketing</td>
                          <td>Marketing</td>
                          <td>VP-Level</td>
                          <td>(407) 933-5887</td>
                          <td>demo.email@gmail.com</td>
                          <td>walmart.com</td>
                          <td>Marketing</td>
                          <td>(407) 933-5887</td>
                          <td>https://app.zoominfo.com/#/apps/profile/person/3116946772</td>
                          <td>https://www.linkedin.com/in/barbara-brown-371b0615</td>
                          <td>702 SW 8th St</td>
                          <td>Columbus</td>
                          <td>Ohio</td>
                          <td>72716</td>
                          <td>United States</td>
                          <td>Walmart</td>
                          <td>corporate.walmart.com</td>
                          <td>(479) 273-4000</td>
                          <td>B2B</td>
                          <td>702 S.w. 8th St</td>
                          <td>Bentonville</td>
                          <td>Arkansas</td>
                          <td>72716</td>
                          <td>United States</td>
                          <td>702 S.w. 8th St, Bentonville, Arkansas, 72716, United States</td>
                        </tr>
                        <tr>
                          <td>
                            <button type="button" class="btn customroweditbtn">
                             <i class="mdi mdi-dots-vertical"></i>
                            </button>
                          </td>
                          <td>01</td>
                          <td>Answered</td>
                          <td>02-08-2023</td>
                          <td>15-10-2023</td>
                          <td className='textunset'>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words</td>
                          <td>Barbara</td>
                          <td>Brown</td>
                          <td>Sams Club Vice President, Marketing</td>
                          <td>Marketing</td>
                          <td>VP-Level</td>
                          <td>(407) 933-5887</td>
                          <td>demo.email@gmail.com</td>
                          <td>walmart.com</td>
                          <td>Marketing</td>
                          <td>(407) 933-5887</td>
                          <td>https://app.zoominfo.com/#/apps/profile/person/3116946772</td>
                          <td>https://www.linkedin.com/in/barbara-brown-371b0615</td>
                          <td>702 SW 8th St</td>
                          <td>Columbus</td>
                          <td>Ohio</td>
                          <td>72716</td>
                          <td>United States</td>
                          <td>Walmart</td>
                          <td>corporate.walmart.com</td>
                          <td>(479) 273-4000</td>
                          <td>B2B</td>
                          <td>702 S.w. 8th St</td>
                          <td>Bentonville</td>
                          <td>Arkansas</td>
                          <td>72716</td>
                          <td>United States</td>
                          <td>702 S.w. 8th St, Bentonville, Arkansas, 72716, United States</td>
                        </tr>
                        <tr>
                          <td>
                            <button type="button" class="btn customroweditbtn">
                             <i class="mdi mdi-dots-vertical"></i>
                            </button>
                          </td>
                          <td>01</td>
                          <td>Answered</td>
                          <td>02-08-2023</td>
                          <td>15-10-2023</td>
                          <td className='textunset'>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words</td>
                          <td>Barbara</td>
                          <td>Brown</td>
                          <td>Sams Club Vice President, Marketing</td>
                          <td>Marketing</td>
                          <td>VP-Level</td>
                          <td>(407) 933-5887</td>
                          <td>demo.email@gmail.com</td>
                          <td>walmart.com</td>
                          <td>Marketing</td>
                          <td>(407) 933-5887</td>
                          <td>https://app.zoominfo.com/#/apps/profile/person/3116946772</td>
                          <td>https://www.linkedin.com/in/barbara-brown-371b0615</td>
                          <td>702 SW 8th St</td>
                          <td>Columbus</td>
                          <td>Ohio</td>
                          <td>72716</td>
                          <td>United States</td>
                          <td>Walmart</td>
                          <td>corporate.walmart.com</td>
                          <td>(479) 273-4000</td>
                          <td>B2B</td>
                          <td>702 S.w. 8th St</td>
                          <td>Bentonville</td>
                          <td>Arkansas</td>
                          <td>72716</td>
                          <td>United States</td>
                          <td>702 S.w. 8th St, Bentonville, Arkansas, 72716, United States</td>
                        </tr>
                        <tr>
                          <td>
                            <button type="button" class="btn customroweditbtn">
                             <i class="mdi mdi-dots-vertical"></i>
                            </button>
                          </td>
                          <td>01</td>
                          <td>Answered</td>
                          <td>02-08-2023</td>
                          <td>15-10-2023</td>
                          <td className='textunset'>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words</td>
                          <td>Barbara</td>
                          <td>Brown</td>
                          <td>Sams Club Vice President, Marketing</td>
                          <td>Marketing</td>
                          <td>VP-Level</td>
                          <td>(407) 933-5887</td>
                          <td>demo.email@gmail.com</td>
                          <td>walmart.com</td>
                          <td>Marketing</td>
                          <td>(407) 933-5887</td>
                          <td>https://app.zoominfo.com/#/apps/profile/person/3116946772</td>
                          <td>https://www.linkedin.com/in/barbara-brown-371b0615</td>
                          <td>702 SW 8th St</td>
                          <td>Columbus</td>
                          <td>Ohio</td>
                          <td>72716</td>
                          <td>United States</td>
                          <td>Walmart</td>
                          <td>corporate.walmart.com</td>
                          <td>(479) 273-4000</td>
                          <td>B2B</td>
                          <td>702 S.w. 8th St</td>
                          <td>Bentonville</td>
                          <td>Arkansas</td>
                          <td>72716</td>
                          <td>United States</td>
                          <td>702 S.w. 8th St, Bentonville, Arkansas, 72716, United States</td>
                        </tr>
                        <tr>
                          <td>
                            <button type="button" class="btn customroweditbtn">
                             <i class="mdi mdi-dots-vertical"></i>
                            </button>
                          </td>
                          <td>01</td>
                          <td>Answered</td>
                          <td>02-08-2023</td>
                          <td>15-10-2023</td>
                          <td className='textunset'>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words</td>
                          <td>Barbara</td>
                          <td>Brown</td>
                          <td>Sams Club Vice President, Marketing</td>
                          <td>Marketing</td>
                          <td>VP-Level</td>
                          <td>(407) 933-5887</td>
                          <td>demo.email@gmail.com</td>
                          <td>walmart.com</td>
                          <td>Marketing</td>
                          <td>(407) 933-5887</td>
                          <td>https://app.zoominfo.com/#/apps/profile/person/3116946772</td>
                          <td>https://www.linkedin.com/in/barbara-brown-371b0615</td>
                          <td>702 SW 8th St</td>
                          <td>Columbus</td>
                          <td>Ohio</td>
                          <td>72716</td>
                          <td>United States</td>
                          <td>Walmart</td>
                          <td>corporate.walmart.com</td>
                          <td>(479) 273-4000</td>
                          <td>B2B</td>
                          <td>702 S.w. 8th St</td>
                          <td>Bentonville</td>
                          <td>Arkansas</td>
                          <td>72716</td>
                          <td>United States</td>
                          <td>702 S.w. 8th St, Bentonville, Arkansas, 72716, United States</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  
                </div>
              </div>
            </div>




        </div>
        </div>
       
       
        <footer class="footer">
          <div class="d-sm-flex justify-content-center justify-content-sm-between">
            
            <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Copyright © 2023 <a href="http://getbound.ai/">Getbound.ai</a> - All rights reserved</span>
          </div>
        </footer>
     
      </div>


            </div>
        </>
    )
}